var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitterEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#twitter-email_svg__paint0_linear_2135_94849)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.5a2.5 2.5 0 012.5-2.5h15a2.5 2.5 0 012.5 2.5V20h-2v-1.537l-8 3.635-8-3.635V26.5a.5.5 0 00.5.5h8.502v2H12.5a2.5 2.5 0 01-2.5-2.5v-13zm2 2.766l8 3.635 8-3.635V13.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5v2.766zM27.002 26v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter-email_svg__paint0_linear_2135_94849",
    x1: 0.813,
    y1: 0,
    x2: 35.231,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096E1"
  })))));
}

export default SvgTwitterEmail;